module.exports = __webpack_public_path__ + "img/fastWIFI.5683498b.svg";